export const solutionData = [
    {
        index: 0,
        id: 'sol1',
        name: 'ERP',
        title: '주문부터 계약, 고객, 재고, 정산, 손익까지\n 기업의 모든 인적 · 물적자원을 효율적으로\n 관리하는 시스템',
        desc: '회사의 자금, 회계, 구매, 생산, 판매 등 모든 업무의 \n흐름을 효율적으로 관리 할 수 있고, 깔끔하고 세련된 \n사용자 인터페이스 통해 보다 편리한 업무처리와 \n복잡한 계산은 자동처리하여 업무를 처리하는 부분에 있어 시간 절약과 효율성을 극대화할 수 있도록 \n초점을 맞춥니다.',
        point: [
            { id: 'POINT01', name: '알림톡&SMS' },
            { id: 'POINT02', name: 'Fax' },
            { id: 'POINT03', name: 'Auto Call' },
            { id: 'POINT04', name: '재고자동처리' },
            { id: 'POINT05', name: '카드결제\n현금영수증' },
            { id: 'POINT06', name: '정산자동화' },
            { id: 'POINT07', name: '문서 전산화\n리포트출력' },
            { id: 'POINT08', name: 'PC&모바일' }
        ]
    },
    {
        index: 1,
        id: 'sol2',
        name: 'CRM',
        title: '협력고객사와의 판매관리, 마케팅 자동화, 고객서비스 지원 등 원활한 비즈니스 상호처리를 위한 관리시스템',
        desc: '협력 고객사에게 판매관리 데이터를 실시간으로 공유하고, 광고성 공지성 데이터를 통해 마케팅 활동 효과를 극대화할 수 있으며, 고객 요구사항에 대한 문제해결을 지원하여 고객 만족도를 높이고, 해결 과정을 원활하게 만듭니다.',
        point: [
            { id: 'POINT01', name: '주문접수&조회' },
            { id: 'POINT02', name: '이벤트 관리' },
            { id: 'POINT03', name: '정산내역조회' },
            { id: 'POINT04', name: '사용자별\n접속권한' },
            { id: 'POINT05', name: '그룹사-계열사\n기능 적용' },
            { id: 'POINT06', name: '공지전달' },
            { id: 'POINT07', name: '배송현황조회' }
        ]
    },
    {
        index: 2,
        id: 'sol3',
        name: 'SCM',
        title: '주문접수된 내용에 대한 협력업체의 공급망을 관리하기 위한 시스템',
        desc: '주문 데이터를 실시간으로 추적하고, 공급업체와의 소통을 원활하게 하여 제품의 효율적인 배송을 보장합니다. 이를 통해 재고 수준을 최적화하고, 납품 지연을 최소화합니다. 또한, 시스템은 공급망 전반의 성능을 모니터링하여 비즈니스의 의사결정 과정에 중요한 데이터를 제공합니다. 이러한 기능은 공급망의 유연성을 높이고, 고객 만족도를 향상시키는 데 기여합니다.',
        point: [
            { id: 'POINT01', name: '발주접수' },
            { id: 'POINT02', name: 'QR코드&바코드\n제품출하' },
            { id: 'POINT03', name: '배송등록' },
            { id: 'POINT04', name: '고객관리' },
            { id: 'POINT05', name: '정산관리' },
            { id: 'POINT06', name: '세금계산서\n발행' },
            { id: 'POINT07', name: '카드결제\n현금영수증' },
            { id: 'POINT08', name: '이미지업로드' }
        ]
    },
    {
        index: 3,
        id: 'sol4',
        name: '고도화',
        title: '기존의 시스템을 개선하여 기능을 향상시키고, 성능 및 사용자 인터페이스 개선할 수 있습니다. 이는 업무의 효율성을 증가시키고 경쟁력을 강화하는 데 중요한 역할을 합니다.',
        desc: '기존 시스템을 업그레이드 하여 성능 개선, 기능 추가, 사용자 경험 개선 등을 포함할 수 있으며, 기업이나 기관의 효율성과 경쟁력을 높이는 것을 목표로 합니다. 고도화는 최신 기술의 통합, 프로세스의 최적화, 사용자 인터페이스의 개선 등을 포함할 수 있습니다. 또한, 시장 변화나 기술 발전에 대응하기 위해 필수적인 과정이기도 합니다.',
        point: [
            { id: 'POINT01', name: 'API연동' },
            { id: 'POINT02', name: '기존 데이터\n동기화' },
            { id: 'POINT03', name: 'Auto Call' },
            { id: 'POINT04', name: '알림톡' },
            { id: 'POINT05', name: '카드결제\n현금영수증' },
            { id: 'POINT06', name: '정산자동화' },
            { id: 'POINT07', name: '문서 전산화\n리포트출력' },
            { id: 'POINT08', name: 'PC&모바일' }
        ]
    }
]; 